import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { Heat } from "@/common/model/Heat";

type ConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (passedHeat: Heat) => void;
  passedHeat: Heat;
};

function ConfirmationDialog({
  open,
  onClose,
  onConfirm,
  passedHeat,
}: ConfirmationDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Deletion of: {passedHeat.name}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this item? This action cannot be
          undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "blue",
            "&:hover": { backgroundColor: "darkblue" },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm(passedHeat);
            onClose();
          }}
          variant="contained"
          sx={{
            backgroundColor: "red",
            "&:hover": { backgroundColor: "darkblue" },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
